import { FC } from 'react'

const UsedTransferBadge: FC<{ className?: string }> = ({ className }) => (
	<span
		className={`inline-flex shrink-0 items-center whitespace-nowrap text-[9px] leading-none text-amber-300 bg-amber-500/15 px-1.5 py-1 rounded ${className || ''}`}
	>
		Used Transfer
	</span>
)

export default UsedTransferBadge
